import { Row, Col, Form, Input, Button, Typography, Tooltip } from 'antd';
import { useEffect, useState } from 'react';
import { useSearchParams } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { TFunction } from 'types';
import { lspLoginUrl } from 'config';
import { useSetNewPasswordPage } from './useSetNewPassword';

export default function SetNewPassword () {

  const {
    isSettingNewPassword,
    setNewPassword,
    hasSetNewPassword,
    failedSettingNewPassword,
  } = useSetNewPasswordPage();

  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");

  const [form] = Form.useForm();
  const { t }: TFunction = useTranslation();
  const [showSuccessScreen, setShowSuccessScreen] = useState(false);

  useEffect(() => {

    if (token?.length) {

      form.submit();

    }

  }, []);

  useEffect(() => {

    if (!failedSettingNewPassword && hasSetNewPassword) {
    
      setShowSuccessScreen(true);

    }

  }, [failedSettingNewPassword, hasSetNewPassword])

  const onFinish = (values: any) => {

    setNewPassword(values);

  }

  const renderValidateForm = () => {

    return (
      <>
        <Col 
          xs={24}
          // style={{mar}}
        >
          <Typography.Title level={1} style={{ textAlign: 'center' }}>
            {t('SetNewPassword')}
          </Typography.Title>
          <Form
            form={form}
            layout="vertical"
            style={{ fontSize: 18 }}
            onFinish={onFinish}
            initialValues={{
              token,
            }}
            validateTrigger="onChange"
          >
            <Form.Item
              // label={t('Password')}
              hidden
              name="token"
              rules={[
                {
                  required: true,
                  message: t('TokenIsRequired'),
                },
              ]}
            >
              <Input

                placeholder={t('Code')}
                size="large"
                type="test"
              />
            </Form.Item>
            <Form.Item
              // label={t('Password')}
              name="newPassword"
              rules={[
                {
                  required: true,
                  message: t('PasswordIsRequired'),
                },
                {
                  min: 8,
                  message: t('PasswordMustBeAtLeast8Characters'),
                },
                {
                  pattern: /^(?=.*[A-Z])(?=.*\d).{8,}$/,
                  message: t('PasswordMustContainAtLeastOneUppercaseLetterAndOneNumber'),
                },
              ]}
            >
              <Input.Password
                placeholder={t('NewPassword')}
                size="large"
              />
            </Form.Item>
            <Form.Item>
              <Button
                disabled={isSettingNewPassword}
                type="primary"
                size="large"
                style={{
                  width: '100%',
                  fontSize: 14,
                  backgroundColor: '#ff6b3d',
                  height: 46,
                }}
                onClick={ async (e) => {

                  e.preventDefault();

                  form.submit();

                }}
              >
                {t('Save')}
              </Button>
            </Form.Item>
          </Form>
        </Col>
      </>
    );
  }

  const renderSuccessScreen = () => {

    return (
      <>
        <Col 
          xs={24}
          style={{
            textAlign: 'center',
          }}
        >
          <Typography.Title level={1} style={{ textAlign: 'center' }}>
            {t('Done')} 
          </Typography.Title>
          <Typography.Text style={{ textAlign: 'center' }}>{t('PasswordHasBeenChanged')} {t('StartByLoggingIn')}</Typography.Text>
          <br />
          <Button
            type="primary"
            href={lspLoginUrl}
            style={{
              textAlign: 'center',
              marginTop: 20,
              padding: 20,
              background: "#494948",
            }}>
              {t('Login')}
          </Button>
        </Col>
      </>
    )

  }

  return (
    <>
      <Row
        style={{
          width: 320,
        }}
      >
        {showSuccessScreen ? renderSuccessScreen() : renderValidateForm()}
      </Row>
    </>
  )

}